import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setSelectedRouter, reportDWH } from '../saleJetBlockSlice';
import { getSalePricesAsync, getTechnicianTimesAsync } from '../saleBlockAsyncThunk';
import Routers from '../Partials/Routers/Routers';

const RouterPage = (props) => {
  const [errorMsg, setErrorMsg] = useState("");

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> על מנת להתחבר לרשת הסיבים <br /> יש צורך בנתב בבית </h1>
      <h2 className='sale-title-small'> האם יש לך צורך בנתב? </h2>
    </div>
  );

  let currentPageView = <Routers routers={props.routers} onSelectRouter={handleSelectRouter} routerImage={props.routerImage} routerPopupText={props.routerPopupText} errorMsg={errorMsg} isLoadingShoppingCart={props.isLoadingShoppingCart} />;

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handleSelectRouter(router) {
    props.setSelectedRouter(router);
    props.getSalePricesAsync();
    setErrorMsg('');
  }

  function handlePageContinue() {
    if (Object.keys(props.selectedRouter).length === 0) {
      setErrorMsg('אנא בחר אחת מן מהאפשרויות');
      return;
    }

    const hasSuperWifi = props.saleCatalog.superWifiList.find((x) => x.action == 'Add');
    const displaySuperWifi = (state.selectedPackage?.downloadSpeed != 2500);

    if ((props.orderType == 'provide' && props.isDisplaySuperWifi) || (props.orderType == 'replace' && hasSuperWifi && displaySuperWifi)) {
      props.goToPage('superWifiPage');
    }
    else {
      if (props.saleType == 'triple') {
        props.goToPage('convertersPage');
      }
      else {
        props.getTechnicianTimesAsync();
      }
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    orderType: state.saleJetBlock.orderType,
    offerName: state.saleJetBlock.offerName,
    routers: state.saleJetBlock.saleCatalog.routers,
    routerImage: state.saleJetBlock.saleBlockData.routerImage,
    routerPopupText: state.saleJetBlock.saleBlockData.routerPopupText,
    isDisplaySuperWifi: state.saleJetBlock.saleBlockData.isDisplaySuperWifi,
    selectedRouter: state.saleJetBlock.selectedRouter,
    isLoadingShoppingCart: state.saleJetBlock.isLoadingShoppingCart,
    saleCatalog: state.saleJetBlock.saleCatalog
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedRouter,
  getSalePricesAsync,
  getTechnicianTimesAsync,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterPage);
